import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider } from 'antd';
import App from './App';
import './styles/index.css';
import { THEME_COLORS, applyThemeCssVariables } from './config/theme.config';
import { queryClient } from './config/queryClient';

applyThemeCssVariables();

const theme = {
  token: {
    colorPrimary: THEME_COLORS.primary,
    colorSuccess: THEME_COLORS.success,
    colorWarning: '#f59e0b',
    colorError: '#ef4444',
    colorInfo: THEME_COLORS.primaryLight,
    borderRadius: 10,
    borderRadiusLG: 16,
    borderRadiusSM: 8,
    fontFamily: "'Roboto', 'Poetsen One', sans-serif",
    colorBgContainer: THEME_COLORS.cardBg,
    colorBgLayout: THEME_COLORS.canvas,
    colorBorder: THEME_COLORS.primaryPale,
    colorBorderSecondary: THEME_COLORS.primaryPale,
    colorTextHeading: THEME_COLORS.primary,
    colorLink: THEME_COLORS.primary,
    colorLinkHover: THEME_COLORS.primaryLight,
    boxShadow: `0 2px 8px rgba(${THEME_COLORS.primaryRgb},0.10)`,
    boxShadowSecondary: `0 4px 20px rgba(${THEME_COLORS.primaryRgb},0.15)`,
  },
  components: {
    Button: {
      borderRadius: 9999,
      borderRadiusLG: 9999,
      borderRadiusSM: 9999,
    },
    Menu: {
      itemBg: 'transparent',
      itemSelectedBg: `rgba(${THEME_COLORS.primaryRgb},0.16)`,
      itemHoverBg: `rgba(${THEME_COLORS.primaryRgb},0.10)`,
      itemColor: THEME_COLORS.textMuted,
      itemHoverColor: THEME_COLORS.primary,
      itemSelectedColor: THEME_COLORS.primary,
      itemBorderRadius: 10,
    },
    Table: {
      headerBg: THEME_COLORS.primaryPale,
      headerColor: THEME_COLORS.primary,
    },
    Card: { borderRadius: 16 },
    Modal: { borderRadius: 20 },
    Input: { borderRadius: 10 },
    Select: { borderRadius: 10 },
  },
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConfigProvider theme={theme}>
        <App />
      </ConfigProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
